import { SpinnerStyled } from './Spinner.styles';

const Spinner = () => {
  return <SpinnerStyled />;
};

export default Spinner;
